export class TimeStepValueDTO {
  constructor(
    readonly timestamp: string,
    readonly maxFloodLevel: number,
    readonly maxIntensity: number,
    readonly maxRisk: number,
    readonly maxRt: number,
    readonly maxTa: number,
  ) {}
}
